import React from 'react';
import { Grid } from '@mui/material';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import CampaignsTable from 'pages/Campaigns/Table/Table';
import { CampaignsContextProvider, useCampaignsContext } from 'pages/Campaigns/campaigns.context';
import { StoresContextProvider } from 'pages/Stores/stores.context';
import { UsersContextProvider } from 'context/users.context';
import ContentWrapper from 'components/StyledComponents/ContentWrapper';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import CreateCampaign from './CreateCampaign';

const CampaignsComponent = (): JSX.Element => {
  const { loading, error } = useCampaignsContext();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message='There was an error loading Campaigns' />;
  }

  return (
    <>
      <SectionHeader pageHeader title='Campaigns' actions={<CreateCampaign />} />
      <ContentWrapper>
        <CampaignsTable />
      </ContentWrapper>
    </>
  );
};

// wrapping component in context provider for full access
const Campaigns = () => (
  <UsersContextProvider>
    <CampaignsContextProvider>
      <StoresContextProvider>
        <CampaignsComponent />
      </StoresContextProvider>
    </CampaignsContextProvider>
  </UsersContextProvider>
);

export default Campaigns;
